"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
const sleep = (millis) => {
    if (millis === 0) {
        return;
    }
    return new Promise((resolve) => setTimeout(resolve, millis));
};
exports.sleep = sleep;
